import router from '../../router';
import client from '../../lib/http-client';
import { removeCookie } from '../../lib/cookie';
import userApi from '../../api/user';
import AuthService from '../../auth/AuthService';

const auth = new AuthService();
const {
	setLocalSession,
} = auth;

const LOGIN = 'LOGIN';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILED = 'LOGIN_FAILED';
const LOGOUT = 'LOGOUT';
const SET_USER = 'SET_USER';
const FETCH_USER_START = 'FETCH_USER_START';
const FETCH_USER_END = 'FETCH_USER_END';
const NAVIGATE = 'NAVIGATE';
const SET_LOCALE = 'SET_LOCALE';
const SET_CUSTOM_NAV_LOGO = 'SET_CUSTOM_NAV_LOGO';

const sessionCookieName = 'mm_user';
// const domain = 'mymeet.no';

const state = function () {
	return {
		location: '/',
		user: '',
		isFetchingUser: false,
		locale: 'no',
		isLoggedIn: !!localStorage.getItem('access_token'),
		loginError: false,
		pending: false,
		messages: [],
		events: [],
		isSocketConnected: false,
		packageVersion: process.env.VUE_APP_VERSION || '2.0.0',
		customNavLogo: null,
	};
};

const mutations = {
	[LOGIN](state) {
		state.pending = true;
	},
	[LOGIN_SUCCESS](state) {
		state.isLoggedIn = true;
		state.loginError = false;
		state.pending = false;
	},
	[LOGIN_FAILED](state, errorMessage) {
		state.loginError = errorMessage;
		state.pending = false;
	},
	[LOGOUT](state) {
		state.user = false;
		state.isLoggedIn = false;
	},
	[FETCH_USER_START](state) {
		state.isFetchingUser = true;
	},
	[FETCH_USER_END](state) {
		state.isFetchingUser = false;
	},
	[SET_USER](state, user) {
		state.user = user;
	},
	[SET_LOCALE](state, locale) {
		state.locale = locale;

		localStorage.setItem('language', locale);
	},
	[NAVIGATE](state, to) {
		state.location = to;
	},
	[SET_CUSTOM_NAV_LOGO](state, logo) {
		state.customNavLogo = logo;
	},
	SOCKET_CONNECT(state) {
		state.isSocketConnected = true;
	},
	SOCKET_DISCONNECT(state) {
		state.isSocketConnected = false;
	},
};

const actions = {
	loginProcess({ commit }) {
		commit(LOGIN);
	},
	loginSuccess({ commit }) {
		commit(LOGIN_SUCCESS);
	},
	loginSuccessLocal({ commit }, data) {
		setLocalSession(data);
		commit(LOGIN_SUCCESS);
	},
	loginFailed({ commit }) {
		commit(LOGIN_FAILED);
	},
	login({ commit, dispatch }) {
		commit(LOGIN_SUCCESS);
		dispatch('fetchUser');
	},
	logout({ commit }) {
		commit(LOGOUT);
		// commit('clients/RESET_STATES');
		// commit('users/RESET_STATES');
		// commit('eventAgendaVotings/RESET_STATES');
		// commit('now/RESET_STATES');
		// commit('eventSuggestionProcessing/RESET_STATES');
		// commit('eventReports/RESET_STATES');

		removeCookie(sessionCookieName);
		localStorage.removeItem('access_token');
		localStorage.removeItem('id_token');
		localStorage.removeItem('expires_at');
		localStorage.removeItem('access_agenda_code');
		localStorage.removeItem('access_agenda_id');

		delete client.defaults.headers.Authorization;
		router.replace('/login');
	},
	navigate({ commit }, to) {
		commit(NAVIGATE, to);
	},
	setUser({ commit }, user) {
		commit(SET_USER, user);
	},
	fetchUser({ commit }) {
		if (this.isFetchingUser) {
			return;
		}
		commit(FETCH_USER_START);
		const callback = function (response) {
			const user = response.data;
			commit(FETCH_USER_END);
			commit(SET_USER, user);
			commit(SET_LOCALE, user.language);
		};
		const errorCallback = function () {
			commit(FETCH_USER_END);
		};
		userApi.getProfile(callback, errorCallback);
	},
	setLocale({ commit }, locale) {
		commit(SET_LOCALE, locale);
	},
	setCustomNavLogo({ commit }, logo) {
		commit(SET_CUSTOM_NAV_LOGO, logo);
	},
};

const getters = {
	user: state => state.user,
	locale: (state) => {
		const locale = state.locale === null ? 'no' : state.locale;
		return locale;
	},
	isLoggedIn: state => state.isLoggedIn,
	isFetchingUser: state => state.isFetchingUser,
	isSocketConnected: state => state.isSocketConnected,
	loginError: state => state.loginError,
	pending: state => state.pending,
	isMenuActive: state => menuName => state.location.to.path === menuName,
	messages: state => state.messages,
	events: state => state.events,
	location: state => state.location,
	appVersion: state => state.packageVersion,
	isClient: state => state.user && state.user.role === 'client',
	isSuperAdmin: state => state.user && state.user.role === 'super_admin',
	customNavLogo: state => state.customNavLogo,
};

export default {
	state,
	getters,
	actions,
	mutations,
};
